import {
  Products
} from "@/services/products.service"; //TODO: porządek z api

function searchTree(element, id) {
  if (element.id == id) {
    return element;
  } else if (element.children != null) {
    let result = null;
    for (let i = 0; result == null && i < element.children.length; i++) {
      result = searchTree(element.children[i], id);
    }
    return result;
  }
  return null;
}

const state = {
  categories: [],
  products: []
};

const getters = {
  categories(state) {
    return state.categories;
  },
  root(state) {
    return {
      id: 0,
      name: "Kategoria nadrzędna",
      children: state.categories
    }
  },
  products(state) {
    return state.products;
  }
};

const actions = {
  async get({
    commit
  }) {
    const {
      data
    } = await Products.get();
    commit('setProducts', data.products);
    return data.products;
  },
  save({
    commit,
    state
  }, body) {
    return Products.save(body)
      .then(({
        data
      }) => {
        if (body.id) {
          commit('setProducts', [...state.products.map((product) => {
            if (product.id === body.id) return data;
            // if (product.id === data.id) return data;
            return product;
          })]);
          return;
        }
        commit('setProducts', [...state.products, data]);
      });
  },
  remove({
    state,
    commit
  }, id) {
    if (!id) return;
    return Products.remove(id)
      .then(() => {
        let removed = state.products.filter((product) => {
          return product.id !== id
        })
        commit('setProducts', [...removed]);
      });
  },
  async getCategories({
    commit
  }) {
    const {
      data
    } = await Products.getCategories();
    commit('setCategories', data.productscategories);
    return data.productscategories;
  },
  addCategory(state, body) {
    if (!body.parent_id) delete body.parent_id;
    return Products.addCategory(body);
  },
  removeCategory(state, id) {
    if (!id) return;
    return Products.removeCategory(id);
  },
  editCategory(state, {
    id,
    body
  }) {
    return Products.editCategory(id, body);
  }
};


const mutations = {
  setProducts(state, products) {
    state.products = products;
  },
  setCategories(state, categories) {
    state.categories = categories;
  },
  removeFromParent(state, {
    id,
    parent_id
  }) {
    const root = getters.root(state);
    const parent = searchTree(root, parent_id);
    parent.children = [...parent.children.filter((child) => child.id !== id)];
    state.categories = root.children;
  },
  pushToParent(state, {
    element,
    parent_id
  }) {
    const root = getters.root(state);
    const parent = searchTree(root, parent_id);
    parent.children.push(element);
    state.categories = root.children;
  },
};


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};